export default {
    isEmptyObject: (obj) => {  //对象是否为空
        if (typeof obj == 'string') {
            if (obj == '') return true;
            return false;
        };

        if (obj == null) return true;
        let ownPropertyKeys = Object.getOwnPropertyNames(obj);
        if (ownPropertyKeys.length == 0) {
            return true;
        } else {
            return false;
        }
    },
    //防抖
    _debounce: (fn, delay) => {
        delay = delay || 500;
        let timer = null;
        return function (param) {
            if (timer) {
                window.clearTimeout(timer);
                timer = null;
            };
            timer = window.setTimeout(() => {
                fn.call(this, param);
                timer = null;
            }, delay);
        };
    },
};